import { DataSource, RemoteSource } from '@components-common/types';
import { useApiGenericClient, useHttpClient } from '../../hooks';
import { useQuery, useQueryClient } from 'react-query';
import { useApiUrlBuilder } from './use-api.hook';
import { useEffect, useMemo } from 'react';
import { isRemoteSource } from '../../components-common/tables/dirootie';

export const useApiGet = <T>() => {
  const build = useApiUrlBuilder();
  const httpClient = useHttpClient();
  return useMemo(() => async (source: RemoteSource) => {
      const url = build(source.url, source.urlParams);
      const res = await httpClient.get<T>(url);
    return res.body;
    }, [build,httpClient])
}

export const useGet = (source: DataSource) => {
  const queryClient = useQueryClient();
  const get = useApiGet();
  const {key} = source;
  const { data, isLoading } = useQuery(
    [key],
    () => get(source as RemoteSource),
    {
      keepPreviousData: false,
      staleTime: 50000,
    }
  );

  useEffect(() => {
    if (!data && isRemoteSource(source)) {
      queryClient.fetchQuery([key], () => get(source as RemoteSource));
    }
  }, [queryClient, key, source, get, data]);

  return { data, isLoading };
};
